import styled from '@emotion/styled';
import { Spinner } from '@prometheus/components';

export const LayoutSpinner = styled(Spinner)`
  margin-top: 20%;
`;
